import { render, staticRenderFns } from "./LocationCardInfo.vue?vue&type=template&id=2e7981fb&scoped=true"
import script from "./LocationCardInfo.vue?vue&type=script&lang=ts"
export * from "./LocationCardInfo.vue?vue&type=script&lang=ts"
import style0 from "./LocationCardInfo.vue?vue&type=style&index=0&id=2e7981fb&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e7981fb",
  null
  
)

export default component.exports